
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function BookMurusjanjiracabfrompune() {



    const cardData =
    {
        keyword: 'Pune to Murud Janjira Taxi Services',
        heading: 'S9 Travels: Pune to Murud Janjira Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Murud Janjira. Whether you are planning to explore the historic Murud Janjira Fort, enjoy the scenic coastal views, or simply unwind, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Murud Janjira is approximately 150 km from Pune, and the journey takes around 4 to 5 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Murud Janjira with S9 Travels',

        "topPlaces": [
            {
              "title": "Murud Janjira Fort",
              "description": "The main attraction in Murud, the Murud Janjira Fort, is a historic sea fort located on an island off the coast. Accessible by boat, the fort offers a glimpse into the region's history and military significance. The fort's impressive architecture and strategic location make it one of Maharashtra's most intriguing forts."
            },
            {
              "title": "Nandgaon Beach",
              "description": "Nandgaon Beach, located near Murud Janjira, is known for its quiet, unspoiled beauty. The beach is ideal for a relaxing day out, offering a peaceful escape with golden sands, clear waters, and breathtaking views of the Arabian Sea. It’s perfect for a picnic or a leisurely walk along the coast."
            },
            {
              "title": "Kashid Beach",
              "description": "About 12 km from Murud, Kashid Beach is one of the most popular beaches in the region. With its clean sands, crystal-clear waters, and lush surroundings, it’s an ideal spot for swimming, sunbathing, and enjoying water sports like parasailing and jet-skiing. Kashid Beach is also known for its vibrant nightlife with beachside shacks and restaurants."
            },
            {
              "title": "Murud Beach",
              "description": "The beach near the Murud Janjira Fort offers tranquil surroundings, making it perfect for a quiet walk along the shore. You can take a boat ride from here to reach the Janjira Fort. It’s also a great place to relax while enjoying the beautiful coastal views and calm atmosphere."
            },
            {
              "title": "Janjira Beach",
              "description": "Another secluded beach near the Murud Janjira Fort, Janjira Beach is known for its pristine beauty. The peaceful environment, along with the opportunity to view the fort from the coast, makes it an excellent spot for photography and relaxation."
            },
            {
              "title": "Phansad Wildlife Sanctuary",
              "description": "Located about 20 km from Murud Janjira, the Phansad Wildlife Sanctuary is a haven for nature lovers and wildlife enthusiasts. It is home to a variety of wildlife, including leopards, deer, and a wide range of birds. The sanctuary also has beautiful trekking trails and is an excellent place to explore the natural beauty of the region."
            },
            {
              "title": "Kondvil Village",
              "description": "Kondvil Village, located near Murud Janjira, is a quaint village known for its peaceful atmosphere and natural beauty. It is a great place to experience local culture and lifestyle, with lush greenery and scenic views of the surrounding landscapes."
            },
            {
              "title": "Dattagiri Fort",
              "description": "Located on a hill near Murud, Dattagiri Fort offers a stunning view of the Arabian Sea. Although the fort is in ruins, it provides an interesting historical perspective and is an excellent trekking destination for adventure lovers."
            },
            {
              "title": "Harnai Beach",
              "description": "About 25 km from Murud Janjira, Harnai Beach is a serene and less crowded beach, ideal for those who prefer a peaceful retreat. The beach is great for swimming, and you can also enjoy fresh seafood from local vendors."
            },
            {
              "title": "Janjira Lighthouse",
              "description": "The Janjira Lighthouse is located near Murud Janjira Fort and offers fantastic views of the coastline and the Arabian Sea. The lighthouse is an interesting historical site and provides a great photo opportunity with its stunning surroundings."
            }
          ],

"services": [
  {
    "name": "Pune to Murud Janjira Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Murud Janjira. Whether you're traveling for leisure, relaxation, or sightseeing, enjoy a smooth and hassle-free ride. Book your Pune to Murud Janjira taxi today!"
  },
  {
    "name": "Pune to Murud Janjira Cab Service",
    "description": "Choose S9 Travels for a professional and dependable cab service from Pune to Murud Janjira. Our experienced drivers and well-maintained vehicles ensure a safe and comfortable journey, allowing you to enjoy the scenic route."
  },
  {
    "name": "Pune to Murud Janjira One-Way Taxi",
    "description": "S9 Travels provides affordable and convenient one-way taxi services from Pune to Murud Janjira. Travel directly to your destination with comfort and ease. Book your one-way taxi today for a stress-free experience."
  },
  {
    "name": "Pune to Murud Janjira Round Trip",
    "description": "For a round trip from Pune to Murud Janjira, S9 Travels offers flexible and reliable options. We ensure that your journey is smooth and timely, with professional drivers to make your round trip comfortable and hassle-free."
  },
  {
    "name": "Murud Janjira Car Rental from Pune",
    "description": "Looking for a car rental for your trip from Pune to Murud Janjira? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles to suit your preferences and needs."
  },
  {
    "name": "Pune to Murud Janjira Taxi Fare",
    "description": "S9 Travels provides transparent and affordable taxi fares for your Pune to Murud Janjira journey. We ensure you get the best value without hidden charges. Contact us for an accurate fare estimate and plan your trip accordingly."
  }
],


"tableData": [
  ["Book Murud Janjira Taxi from Pune", "Book Pune To Murud Janjira Cab Service"],
  ["Book Pune To Murud Janjira One-Way Taxi", "Book Pune To Murud Janjira Round Trip"],
  ["Book Murud Janjira Car Rental from Pune", "Book Pune To Murud Janjira Taxi Fare"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of timely travel when heading to Murud Janjira. Whether you are visiting the historic Janjira Fort, relaxing by the beach, or just exploring the area, we ensure punctual pickups and drop-offs, so you can enjoy a stress-free journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of comfortable and spacious vehicles, designed to make your ride to Murud Janjira smooth and relaxing. Our air-conditioned vehicles come with comfortable seating and ample space for your luggage, ensuring a pleasant travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are well-trained, experienced, and familiar with the best routes to Murud Janjira. Their professionalism and expertise guarantee a safe, smooth, and enjoyable journey, allowing you to focus on your trip and destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels provides competitive and transparent pricing for your Pune to Murud Janjira trip. We offer a clear breakdown of costs upfront, with no hidden fees, so you know exactly what to expect before you hit the road."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking, to ensure you have a secure and comfortable journey to Murud Janjira."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates 24/7, so whether you are planning an early morning trip or a late-night return, we are always ready to accommodate your schedule. Our customer service team is also available around the clock to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Murud Janjira cab with S9 Travels is quick and easy. You can book online via our website or app, or contact our customer service team for personalized assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you are visiting Murud Janjira for sightseeing, a family getaway, or a peaceful retreat, we offer customized travel packages tailored to your preferences. Let us know your requirements, and we’ll ensure that your trip is memorable and special."
  }
]
















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Murud Janjira cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for assistance with your reservation.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel. They are familiar with the routes to Murud Janjira, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Murud Janjira travel?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars, all well-maintained for comfort and safety during your trip.',
          },
          {
            question: 'How do I pay for my Pune to Murud Janjira cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, for your convenience.',
          },
          {
            question: 'Can I book a round trip from Pune to Murud Janjira?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details, and we will handle the rest for a seamless journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, like waiting time or detours, will be communicated to you upfront, ensuring transparency in our pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Murud Janjira?',
            answer: 'Yes, we offer sightseeing services in Murud Janjira. Explore the famous Janjira Fort, beaches, and other local attractions with our experienced drivers, who can guide you to the best spots.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Murud Janjira cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra luggage or special requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Murud Janjira?',
            answer: 'Yes, we offer corporate travel services for business trips or group outings between Pune and Murud Janjira. Our service is punctual, professional, and tailored to the needs of corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Murud Janjira travel?',
            answer: 'S9 Travels offers a reliable, comfortable, and affordable travel experience. Our professional drivers, well-maintained vehicles, and excellent customer service ensure a smooth and enjoyable trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I had a great experience with S9 Travels for my trip to Murud Janjira. The vehicle was clean, and the driver was friendly and professional. It was a relaxing journey, and I’ll definitely book again!”',
        },
        {
          name: 'Mrs. Priya Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family had an amazing time in Murud Janjira, thanks to S9 Travels. The vehicle was spacious, comfortable, and well-maintained. The driver was knowledgeable about the area and made our trip even more enjoyable.”',
        },
      ];
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Murud Janjira Cab From Pune",
        "description": "Book Murud Janjira taxi services from Pune, one-way taxi, round trip, car rental, and more with S9 Travels. Choose from affordable Pune to Murud Janjira cab booking options for a comfortable and safe journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     


    return (
        <div>

          <Helmet>
        <title>Book Murud Janjira Cab From Pune | S9 Travels</title>
        <meta 
          name="description" 
          content="Book Murud Janjira taxi services from Pune, including one-way taxi, round trip, car rental, and more with S9 Travels. Get the best fares for Pune to Murud Janjira cab booking and enjoy a safe, comfortable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default BookMurusjanjiracabfrompune;